@if (loader) {
    <div class="overlay"></div>
    <p-progressSpinner ariaLabel="loading" class="loading-spinner"></p-progressSpinner>
}